import { BodyText, Heading, Highlight, Image } from '@postscript/components';
import styled from 'styled-components';
import { MediaQueries } from '../Layout/MainLayout';

const StyledHeroBlock = styled.section`
  background: var(--main-bkg-color);
  display: flex;
  align-items: center;

  ${MediaQueries.desktopAndTablet} {
    min-height: 100vh;
    padding: 216px 0;
  }

  > div {
    margin: 0 auto;
    max-width: 1440px;
  }

  ${MediaQueries.desktopOnly} {
    > div {
      padding: 0 96px;
      display: grid;
      grid-template-columns: repeat(2, 50%);
      grid-column-gap: var(--spacing-4);
      > div > * {
        width: 100%;
      }
    }

    img {
      margin-top: -12%;
    }
  }

  ${MediaQueries.tabletOnly} {
    > div {
      padding: 0 48px;
    }

    img {
      display: none;
    }
  }

  ${MediaQueries.phoneOnly} {
    min-height: 80vh;
    padding: 60px 0;

    > div {
      display: flex;
      flex-direction: column-reverse;
      padding: 0 24px;
    }

    img {
      max-width: 280px;
      margin: 0 auto var(--spacing-6);
    }
  }
`;

const StyledHeroHeading = styled(Heading)`
  margin-bottom: var(--spacing-1);
  text-shadow: var(--main-bkg-color) 1px 0 12px;

  @media only screen and (min-width: 1281px) {
    font: 700 7.5rem/6.25rem var(--heading-typeface);
  }

  @media only screen and (min-width: 768px) and (max-width: 1280px) {
    font: 700 9vw/7.56vw var(--heading-typeface);

    & + p {
      font: 2vw/2.72vw var(--body-text-typeface);
      text-shadow: var(--main-bkg-color) 1px 0 6px;
    }
  }

  ${MediaQueries.phoneOnly} {
    font: 700 18vw/15.12vw var(--heading-typeface);

    & + p {
      text-shadow: var(--main-bkg-color) 1px 0 6px;
    }
  }
`;

const HeroSection = (): JSX.Element => {
  return (
    <StyledHeroBlock data-theme="dark" id="home">
      <div>
        <div>
          <StyledHeroHeading forwardedAs="h1" size="large">
            <Highlight>EMOJI!</Highlight>
            <br />
            DESIGN
            <br />
            MORE
            <br />
            FASTER.
          </StyledHeroHeading>
          <BodyText size="large">
            Welcome to the Postscript Design System! Emoji is a unified language
            of components and patterns that allows Design, Engineering, and
            Product to craft consistent, intentional, and exciting experiences
            for our customers.
          </BodyText>
        </div>
        <Image
          alt="Welcome to Emoji!"
          frame="square"
          src="img/hero-graphic.png"
        />
      </div>
    </StyledHeroBlock>
  );
};

export default HeroSection;
